import Backbone from 'backbone';

import BaseView from '../base-view';
import Suggest from '../components/suggest/index';

export default BaseView.extend({
	events: {
		'click [type="reset"]': 'onFormReset',
		'change .js-handled': 'onDomesticChange'
	},

	initialize: function() {
		// make a dynamic model
		this.model = new Backbone.Model();

		// reference field
		this.inputDate = this.query('.js-date');

		// create filters
		this.createFilters();
	},

	/**
	 * create filters for the view
	 */
	createFilters: function() {
		this.instrumentSuggestView = new Suggest.Views.Main({
			el: '.js-instrument',
			dataUrl: '/autocomplete'
		}).render();

		// date picker
		this.$pickerDate = $('.js-date-selector').pickadate({
			format: 'dd.mm.yyyy',
			max: false
		}).pickadate('picker');
		this.$pickerDate.on('set', this.onDateChange.bind(this));
	},

	/**
	 * Date change handler
	 * fill hidden field with formatted date
	 */
	onDateChange: function(e) {
		var date = new Date(e.select),
			year = date.getFullYear(),
			month = date.getMonth() + 1,
			day = date.getDate();

		// fill hidden input with formatted date
		this.inputDate.value = year + '-' + month + '-' + day;
	},

	/**
	 * Domestic (radio input) change handler
	 * sets 'isDomestic' value based on its checked state
	 */
	onDomesticChange: function(e) {
		var radio = e.currentTarget,
			isin = radio.getAttribute('data-isin'),
			isDomestic = radio.value,
			url = '/extranet/setinstrumentdomestic?instrumentId=' + isin + '&domestic=' + isDomestic;

		this.model.set('id', isin);
		this.flagInstrument(url);
	},

	flagInstrument: function(url) {
		this.model.destroy({
			url: url,
			wait: true,
			method: 'POST'
		});
	},

	/**
	 * resets form and submit it
	 **/
	onFormReset: function(e) {
		// get form
		var form = e.currentTarget.form;

		// clear participant suggest view
		this.instrumentSuggestView.clear();

		// reset and submit form
		form.reset();
		form.submit();
	}
});
